import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../../../util/reactIntl';
import { propTypes } from '../../../../util/types';
import { required } from '../../../../util/validators';

import { FieldReviewRating, Form, PrimaryButton, FieldTextInput } from '../../../../components';

import css from './ProfileNavReviewsForm.module.css';

const ProfileNavReviewsFormComponent = props => (
  <FinalForm
    {...props}
    render={fieldRenderProps => {
      const {
        className,
        rootClassName,
        disabled,
        handleSubmit,
        intl,
        formId,
        form,
        invalid,
        reviewSent,
        sendReviewError,
        sendReviewInProgress,
      } = fieldRenderProps;

      const reviewContentPlaceholderMessage = intl.formatMessage({
        id: 'ProfileNavReviewsForm.reviewContentPlaceholder',
      });
      const reviewContentRequiredMessage = intl.formatMessage({
        id: 'ProfileNavReviewsForm.reviewContentRequired',
      });

      const reviewRatingRequiredMessage = intl.formatMessage({
        id: 'ProfileNavReviewsForm.reviewRatingRequired',
      });

      const errorMessage = sendReviewError ? (
        <p className={css.error}>
          <FormattedMessage id="ProfileNavReviewsForm.reviewSubmitFailed" />
        </p>
      ) : null;

      const reviewSubmitMessage = intl.formatMessage({
        id: 'ProfileNavReviewsForm.reviewSubmit',
      });

      const classes = classNames(rootClassName || css.root, className);
      const submitInProgress = sendReviewInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

      return (
        <Form
          className={classes}
          onSubmit={async values => {
            await handleSubmit(values);
            form.restart();
          }}
        >
          <FieldTextInput
            className={css.reviewContent}
            inputRootClass={css.reviewContentInputRoot}
            type="textarea"
            id={formId ? `${formId}.reviewContent` : 'reviewContent'}
            name="reviewContent"
            placeholder={reviewContentPlaceholderMessage}
            validate={required(reviewContentRequiredMessage)}
          />

          <FieldReviewRating
            className={css.reviewRating}
            id={formId ? `${formId}.starRating` : 'starRating'}
            name="reviewRating"
            validate={required(reviewRatingRequiredMessage)}
          />

          {errorMessage}
          <PrimaryButton
            className={css.submitButton}
            type="submit"
            inProgress={submitInProgress}
            disabled={submitDisabled}
            ready={reviewSent}
          >
            {reviewSubmitMessage}
          </PrimaryButton>
        </Form>
      );
    }}
  />
);

ProfileNavReviewsFormComponent.defaultProps = {
  className: null,
  rootClassName: null,
  sendReviewError: null,
};

const { bool, func, string } = PropTypes;

ProfileNavReviewsFormComponent.propTypes = {
  className: string,
  rootClassName: string,
  intl: intlShape.isRequired,
  onSubmit: func.isRequired,
  reviewSent: bool.isRequired,
  sendReviewError: propTypes.error,
  sendReviewInProgress: bool.isRequired,
};

const ProfileNavReviewsForm = compose(injectIntl)(ProfileNavReviewsFormComponent);
ProfileNavReviewsForm.displayName = 'ProfileNavReviewsForm';

export default ProfileNavReviewsForm;
